var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3285_3693",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3285_3693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 5.83073C10.2374 5.83073 10.4353 5.75087 10.5951 5.59115C10.7548 5.43142 10.8346 5.23351 10.8346 4.9974C10.8346 4.76128 10.7548 4.56337 10.5951 4.40365C10.4353 4.24392 10.2374 4.16406 10.0013 4.16406C9.76519 4.16406 9.56728 4.24392 9.40755 4.40365C9.24783 4.56337 9.16797 4.76128 9.16797 4.9974C9.16797 5.23351 9.24783 5.43142 9.40755 5.59115C9.56728 5.75087 9.76519 5.83073 10.0013 5.83073ZM9.16797 12.4974H10.8346V7.4974H9.16797V12.4974ZM1.66797 18.3307V3.33073C1.66797 2.8724 1.83116 2.48003 2.15755 2.15365C2.48394 1.82726 2.8763 1.66406 3.33464 1.66406H16.668C17.1263 1.66406 17.5187 1.82726 17.8451 2.15365C18.1714 2.48003 18.3346 2.8724 18.3346 3.33073V13.3307C18.3346 13.7891 18.1714 14.1814 17.8451 14.5078C17.5187 14.8342 17.1263 14.9974 16.668 14.9974H5.0013L1.66797 18.3307ZM4.29297 13.3307H16.668V3.33073H3.33464V14.2682L4.29297 13.3307Z",
    fill: "#F5D447"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.99d873f034d4e99f52cb97624978a752.svg";
export { ForwardRef as ReactComponent };